import { BaseModel, type RelationConfig } from './base';
import { dateYMDRelation, type DateYMD } from '../lib/dates';

export class EmployeeBreak extends BaseModel {
  // Ported from the Nuxt 2 `date: { type: DateYMD }` relation. The migration
  // erroneously typed this as `string` and dropped the transform, so consumers
  // (MoveBreak.vue, EditBreak.vue) that read `.date.value` / `.date.date` saw
  // undefined at runtime.
  date!: DateYMD;
  time!: number;
  duration!: number;
  label!: string;
  idEmployeeBreak!: number;
  idEmployeeDefaultBreak!: number;

  static override relations(): RelationConfig {
    return {
      date: dateYMDRelation,
    };
  }

  get startTimeLabel(): number {
    return this.time;
  }

  get finishTimeLabel(): number {
    return this.time + this.duration;
  }
}
